module.exports = __webpack_public_path__ + "static/media/banner_news_licitacoes_gerenciadas.639ee156.png";